/**
 * internal dependencies
 */
import { MONTHS } from "../common/filter-elements";
import { dropdown, displaySelectedValue } from "../../dropdown";

/**
 * Sets up the download dropdown menu with options for current data and previous months.
 * 
 * @returns The current month as a string for use in download logic
 */
export const setDownloadDropDown = (): string => {
  const lastMonths: { id: number; name: string }[] = [];
  const now = new Date();
  let year = now.getFullYear();
  let month = now.getMonth() + 1;
  let currentMonth = month;

  // Start from previous month instead of current month
  if (month === 1) {
    month = 12;
    year--;
  } else {
    month--;
  }

  for (let i = 0; i < 1; i++) {
    lastMonths.push({
      id: month,
      name: MONTHS[parseInt((month > 9 ? "" : "0") + month)] + "-" + year
    });
    if (month === 1) {
      month = 12;
      year--;
    } else {
      month--;
    }
  }

  lastMonths.unshift({ id: 99, name: "Current Data"}, {
    id: currentMonth,
    name: `Month to Date (${MONTHS[parseInt((currentMonth > 9 ? "" : "0") + currentMonth)] + "-" + year})`
  });

  dropdown(lastMonths, "month", "Select", false, true, true);

  displaySelectedValue(".aafp_list-month", "month", "99");
  return currentMonth.toString();
};